import { TaboolaGraph, SORTING_ORDER_TYPES } from 'taboola-ultimate-ui';
import { GRAPHS } from 'modules/campaigns/constants/graphTypes';
import { getDataWithFullPeriodScale } from '../../../transformers/getDataWithFullPeriodScale';
import * as FIELDS from '../../fields';
import { DATE } from '../../fields';
import { hourXAxisFormatterUTC, tooltipHourFormatterUTC } from '../../fields/transformers';
import metrics from '../../metrics';

const { AXIS_SCALE, AXIS_TYPE, AXIS_DOMAIN } = TaboolaGraph;

const graph = {
    graphIdField: DATE.field,
    type: GRAPHS.LINE,
    skipWeekendAreas: true,
    endpoint: 'realtime-campaign-report-by-smallest-time-bucket-performance',
    metrics: [
        metrics.SPENT,
        metrics.VISIBLE_IMPRESSIONS,
        metrics.IMPRESSIONS,
        metrics.CLICKS,
        metrics.VCTR,
        metrics.AVERAGE_CPC,
        metrics.CVR,
        metrics.CVR_CLICKS,
        metrics.CVR_VIEWS,
        metrics.CONVERSIONS,
        metrics.CONVERSIONS_CLICKS,
        metrics.CONVERSIONS_VIEWS,
        metrics.CPA,
        metrics.CPA_CLICKS,
        metrics.CPA_VIEWS,
        metrics.VCPM,
        metrics.CONVERSIONS_VALUE,
        metrics.ROAS,
        metrics.ROAS_CLICKS,
        metrics.ROAS_VIEWS,
    ],
    defaultSort: [{ field: 'date', order: SORTING_ORDER_TYPES.ASCENDANT }],
    graphProps: {
        xAxisDataKey: FIELDS.DATE.field,
        getXAxisFormatter: hourXAxisFormatterUTC,
        toolTipLabelFormatter: tooltipHourFormatterUTC,
        xAxisScale: AXIS_SCALE.LINEAR,
        xAxisType: AXIS_TYPE.NUMBER,
        xAxisDomain: [AXIS_DOMAIN.DATA_MIN, AXIS_DOMAIN.DATA_MAX],
    },
    dataViewTransformer: getDataWithFullPeriodScale,
};

export default graph;
